import { m } from 'framer-motion';

import { Button, Container, Stack, Typography } from '@mui/material';

import { Helmet } from 'react-helmet-async';
import { routes } from 'src/Router/paths';
import { ComingSoonIllustration } from 'src/assets/illustrations';
import { useAuthContext } from 'src/auth/useAuthContext.js';
import { MotionContainer, varBounce } from 'src/components/animate';

export function UnverifiedAccountLocked() {
  const { logout } = useAuthContext();

  const handleLogout = async () => {
    await logout();
    window.location.replace(routes.auth.login);
  };

  return (
    <Stack width={1} py={4} overflow="auto">
      <Helmet>
        <title> Unverified Account | Copera.ai</title>
      </Helmet>

      <Container
        component={MotionContainer}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Unverified Account
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Your account was locked due to an unverified email. To verify, sign
            out from your account and log in again to receive the verification
            email.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ComingSoonIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>

        <m.div variants={varBounce().in}>
          <Button variant="contained" color="error" onClick={handleLogout}>
            Logout
          </Button>
        </m.div>
      </Container>
    </Stack>
  );
}
